import React from "react";
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import { Nav } from "react-bootstrap";


function Heading() {
    return (
        <>
            <Navbar bg="light" variant="dark">
                <Container id="nav-heading">
                    <Navbar.Brand href="#home">
                        <img
                            alt="Viken Blockchain Solutions"
                            src="Viken.png"
                            width="25%"
                            height="25%"
                            className="d-inline-block align-top"
                        />{' '}
                    </Navbar.Brand>
                </Container>
            </Navbar>
            <Nav className="me-auto me-navlink">
                <Nav.Link href="https://vikenblockchain.com">Home</Nav.Link>
                <Nav.Link href="#home">Spread NFT Edition</Nav.Link>
                <Nav.Link href="https://viken-blockchain-solutions.github.io/TicketVault_stats/">Blockchain Tools</Nav.Link>
            </Nav>
        </>
    );
}

export default Heading;

/*  return (
     <>
         <div className="container">
             <div className="row justify-content-center">
                 <div className="col-12 text-center">
                     <nav className="navbar navbar-expand-sm bg-dark navbar-dark sticky-top" style={{fontWeight: "normal", fontFamily: "sans-serif" }}>
                         <a className="navbar-brand p-4" href="index.html" >
                             <span className="d-none d-lg-block" >Spread Dapp</span>
                             <span className="d-none d-lg-block" style={{color: "lightblue"}}>ERC721 Edition</span>
                         </a>
                         <ul className="navbar-nav">
                             <li className="nav-item">
                                 <a className="nav-link" href="https://vikenblockchain.com">Homepage</a>
                             </li>
                             <li className="nav-item">
                                 <a className="nav-link" href="https://viken-blockchain-solutions.github.io/TicketVault_stats/">Viken Blockchain Tools</a>
                             </li>
                             <li className="nav-item">
                                 <a className="nav-link" ><span src="../public/Viken.png"></span></a>
                             </li>
                         </ul>
                     </nav>
                 </div>
             </div>
         </div>
     </>
 );
*/
